module.exports = __webpack_public_path__ + "static/media/discount-tag.7595dac7.svg";